export { default } from "./FeaturedIcon";
